import {
  FormControl,
  FormLabel,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
  useDisclosure,
} from "@chakra-ui/react";
import * as React from "react";
// import { HiEye, HiEyeOff } from "react-icons/hi";

export const PasswordField = (props) => {
  const { isOpen, onToggle } = useDisclosure();
  const onClickReveal = () => {
    onToggle();
  };

  return (
    <FormControl>
      <FormLabel htmlFor="password">Password</FormLabel>
      <InputGroup>
    
        <Input
          id="password"
          name="password"
          type={isOpen ? "text" : "password"}
          required
          onChange={(event) => {
            props.setpassword(event.target.value)
          }}
        />
            <InputRightElement>
          <IconButton
            variant="link"
            aria-label={isOpen ? "Mask password" : "Reveal password"}
            // icon={isOpen ? <HiEyeOff /> : <HiEye />}
            onClick={onClickReveal}
          />
        </InputRightElement>
      </InputGroup>
    </FormControl>
  );
};

PasswordField.displayName = "PasswordField";
